export default __webpack_public_path__ + "static/media/cra-marked.47b81105.png";